<template>
    <BModal v-model="isOpen" size="md" centered hide-footer title="Edit invoice dates">
        <div class="row">
            <div class="col-12">
                <AppDatePicker :value="invoice.issued_at"
                               @input="updateInvoiceProps({ issued_at: $event })"
                               field="issued_at"
                               label="Issued at"
                               :errors="errors"/>
            </div>
            <div class="col-12">
              <div class="row align-items-center">
                <AppDatePicker :value="invoice.due_at"
                               @input="updateInvoiceProps({ due_at: $event })"
                               field="due_at"
                               label="Due at"
                               :errors="errors"
                               class="col-12"
                               :allow-empty="true"/>
              </div>
            </div>
            <div class="col-12">
              <p class="form-text text-muted">
                    <small>
                        <i class="material-icons material-icons-outlined md-18 mr-2">info</i>
                        When first generated <em>Due at</em> is set to
                        be 10 days after <em>issued at</em> date.
                    </small>
              </p>
            </div>
        </div>
        <div class="row mt-3">
            <div class="col-12 text-right">
                <button class="btn btn-primary" @click="save">Save</button>
            </div>
        </div>
    </BModal>
</template>

<script>
import { mapGetters } from 'vuex';
import { BModal } from 'bootstrap-vue';
import Errors from '../../utils/errors';
import AppDatePicker from '../form/AppDatePicker';

export default {
  data() {
    return {
      errors: new Errors(),
      noDueDate: false,
    };
  },
  components: {
    AppDatePicker,
    BModal,
  },
  mounted() {
    if (!this.invoice.due_at) {
      this.noDueDate = true;
    }
  },
  computed: {
    isOpen: {
      get() {
        return this.$store.state.invoices.isDatesModalOpen;
      },
      set(val) {
        this.$store.commit('invoices/isDatesModalOpen', val);
      },
    },
    ...mapGetters({
      invoice: 'invoices/invoice',
    }),
  },
  methods: {
    save() {
      this.$store.commit('invoices/isDatesModalOpen', false);
      this.$store.dispatch('invoices/updateInvoice');
    },
    updateInvoiceProps(props) {
      this.$store.dispatch('invoices/updateInvoiceProps', props);
    },
  },
};
</script>
